import UserProfile from '@/domain/access/domain/profile.enum';

export default class BusinessUnit {
  id: string;

  name: string;

  profile: UserProfile;

  enablePaymentLinkGeneration: boolean;

  enableRevisionFlow: boolean;

  billingDaily: boolean;

  enableNotifyCancelallation: boolean;

  enableContractRevision: boolean;

  constructor(obj: any) {
    this.id = obj.id;
    this.name = obj.name;
    this.profile = obj.profile;
    this.enablePaymentLinkGeneration = obj.enablePaymentLinkGeneration || false;
    this.enableRevisionFlow = obj.enableRevisionFlow || false;
    this.billingDaily = obj.billingDaily || false;
    this.enableNotifyCancelallation = obj.enableNotifyCancelallation || false;
    this.enableContractRevision = obj.enableContractRevision || false;
  }

  public static of(obj: any): BusinessUnit {
    return new BusinessUnit(obj || {})
  }

  public static ofList(obj: any[]): BusinessUnit[] {
    return obj.map(this.of)
  }
}
